import type { RouteLocationMatched, RouteMeta } from 'vue-router';

export interface RouteMetaInformation {
  matched: Array<Pick<RouteLocationMatched, 'meta'>>;
}

export function findMeta(route: RouteMetaInformation, key: keyof RouteMeta): string | undefined {
  // Walk all the matched routes backwards (child -> parent) to find a page title
  for (let i = route.matched.length - 1; i >= 0; i--) {
    if (key in route.matched[i].meta) return route.matched[i].meta[key] as string | undefined;
  }
  return undefined;
}
